<script lang="ts">
  import { afterUpdate } from "svelte";
  import { updateUrlParam } from "../store/AppState";
  import type { ActivityConfig } from "../declarations/config";

  import { activitiesConfig, selectedActivityIndex } from "../store/AppState";
  import {
    sendInteractionEvent,
    INTERACTION_TYPE_SIGNPOST,
    INTERACTION_TYPE_DOWNLOAD,
  } from "../utils/analytics";

  let activityConfig: ActivityConfig;
  const handleClick = () => {
    if (activityConfig !== null) {
      updateUrlParam("aktivita", activityConfig.slug);
      sendInteractionEvent(INTERACTION_TYPE_SIGNPOST, activityConfig.slug);
    }
  };

  const handleStoreClick = () => {
    sendInteractionEvent(INTERACTION_TYPE_DOWNLOAD, activityConfig.slug);
  };

  let buttonText = "Otevřít";
  afterUpdate(() => {
    if ($selectedActivityIndex !== null) {
      activityConfig = $activitiesConfig[$selectedActivityIndex];
      if (activityConfig.type === "game") {
        buttonText = "Hrát";
      } else if (activityConfig.type === "video") {
        buttonText = "Spustit";
      } else {
        buttonText = "Otevřít";
      }
    }
  });
</script>

{#if activityConfig}
  {#if activityConfig.button === "Default"}
    <button on:pointerup={handleClick} class="activity-button"
      ><span>{buttonText}</span></button
    >
  {/if}
  {#if activityConfig.button === "iOS"}
    <a
      class="store-button"
      href={activityConfig.src}
      on:click={handleStoreClick}
      ><img src={`${__PUBLIC_PATH__}images/btn_ios.svg`} alt="iOS" /></a
    >
  {/if}
  {#if activityConfig.button === "Android"}
    <a class="store-button" href={activityConfig.src}
      ><img src={`${__PUBLIC_PATH__}images/btn_android.svg`} alt="Android" /></a
    >
  {/if}
{/if}

<style>
  .activity-button {
    background-color: hsla(19, 88%, 54%, 1);
    border: none;
    color: hsla(0, 0%, 100%, 1);
    height: calc(min(4rem, 7vh));
    padding-top: 0rem;
    padding-bottom: 0rem;
    padding-left: calc(min(1.6rem, 1.3vh));
    padding-right: calc(min(1.6rem, 1.3vh));
    margin-top: calc(min(2.3rem, 2vh));
    border-radius: 0.375rem;

    cursor: default;
  }

  .activity-button span {
    font-family: "source-sans-pro", sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 1.8rem;
    line-height: 2rem;
  }

  .store-button {
    display: inline-block;
    margin-top: 3rem;
  }
</style>
